import cookies, { setCookie, getCookie, removeCookie, updateClsCookieObject } from 'modules/global/cookies';
import {getLCP, getCLS, onINP} from 'web-vitals';
import heartUtils from 'modules/heart-product';

const addToGlobal = (...propTuple) => {
  propTuple.forEach(([name, value]) => {
    window[name] = value;
  });
};

addToGlobal(
  ['docCookies', cookies],
  ['setCookie', setCookie],
  ['getCookie', getCookie],
  ['removeCookie', removeCookie], 
  ['updateHeartCount', heartUtils.updateHeartCount],
  ['getLCP', getLCP],
  ['getCLS', getCLS],
  ['updateClsCookieObject', updateClsCookieObject],
  ['onINP', onINP],
);



// WEBPACK FOOTER //
// ./src/scripts/entry-points/chrome/globals.js